
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import UserAuthContextProvider from './contexts/UserAuthContext';

import ProtectedRouter from "./components/pages/ProtectedRouter";
import UserDashboard from './components/pages/UserDashboard';

import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import UploadPrescription from './components/pages/UploadPrescription';
import Aboutus from './components/pages/Aboutus';
import Contactus from './components/pages/Contactus';
import Health from './components/pages/Health';
import Fashion from './components/pages/Fashion';
import GroomingBook from './components/pages/GroomingBook';
import VetConsult from './components/pages/VetConsult';
import DogFood from './components/pages/DogFood';
import CatFood from './components/pages/CatFood';
import StayBook from './components/pages/StayBook';
import Outlet from './components/pages/Outlet';
import Toys from './components/pages/Toys';
import Litter from './components/pages/Litter';
import Grooming from './components/pages/Grooming';
import Accessories from './components/pages/Accessories';
import PrescriptionDiet from './components/pages/PrescriptionDiet';
import Signup from './components/pages/Signup';
import Login from './components/pages/Login';
import VideoGallery from './components/pages/VideoGallery';
import PhotoGallery from './components/pages/PhotoGallery';
import Privacy from './components/pages/Privacy';
import Terms from './components/pages/Terms';
import DeleteAccount from './components/pages/DeleteAccount';
function App() {
  return (
    <Router>
  <UserAuthContextProvider>
      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
          <Route axact path="/UploadPrescription" element={<UploadPrescription />} />
          <Route axact path="/about-us" element={<Aboutus />} />
          <Route axact path="/contact-us" element={<Contactus />} />
          <Route axact path="/healthproducts" element={<Health />} />
          <Route axact path="/Fashion" element={<Fashion />} />
          <Route axact path="/GroomingBook" element={<GroomingBook />} />
          <Route axact path="/vet-consultancy" element={<VetConsult />} />
          <Route axact path="/dog-food" element={<DogFood />} />
          <Route axact path="/cat-food" element={<CatFood />} />
          <Route axact path="/StayBook" element={<StayBook />} />
          <Route axact path="/our-outlet" element={<Outlet />} />
          <Route axact path="/toys" element={<Toys />} />
          <Route axact path="/litter" element={<Litter />} />
          <Route axact path="/grooming" element={<Grooming />} />
             <Route axact path="/privacy" element={<Privacy />} />
               <Route axact path="/terms" element={<Terms />} />
                 <Route axact path="/DeleteAccount" element={<DeleteAccount/>} />
            <Route axact path="/VideoGallery" element={<VideoGallery/>} />
                     <Route axact path="/PhotoGallery" element={<PhotoGallery/>} />
             <Route axact path="/Login" element={<Login/>} />
            <Route axact path="/_______nd______plazzap" element={<Signup/>} />
          <Route axact path="/accessories" element={<Accessories/>} />
                    <Route axact path="/PrescriptionDiet" element={<PrescriptionDiet/>} />
                                           <Route axact path="/UserDashboard/:userId" element={<ProtectedRouter> <UserDashboard /> </ProtectedRouter>} />

        </Routes>
        <Footer />

      </div>
</UserAuthContextProvider>
    </Router>
  );
}

export default App;
